import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import FlowService from '../../services/flow-service';
import UserSession from '../../services/user-session';

// Flow 391 is the 'nhs' slug flow — stable across environments
const NHS_FLOW_ID = 391;

const CreateAccountPreFlow: React.FC = () => {
  const { search } = useLocation();

  useEffect(() => {
    // No origin rewrite here: the create-account flow (and its Auth0 callback + the mobile
    // handoff) stay on whichever origin they started on. buildCanonicalRedirectUri() uses the
    // current origin, which Auth0 already allows, so localStorage / the sl-user-flow cookie /
    // the sessionStorage redirect_url all remain visible across the round-trip.
    const params = new URLSearchParams(search);
    const redirectUrl = params.get('redirect_url') ?? '';
    const qs = redirectUrl
      ? `?redirect_url=${encodeURIComponent(redirectUrl)}`
      : '';

    // Pre-warm flow 391 at #2/1 (country selector) only when the user is not yet
    // authenticated. Authentication is the exact boundary between the two parts of
    // flow 391: unauthenticated = account-creation questionnaire (should restart from
    // the country selector if re-entering); authenticated = onboarding questionnaire
    // (should resume without flashing the country selector).
    // Vanity flows (nhs-sleepio, wales, etc.) have different API-assigned IDs, so the
    // pre-warm only works reliably for flow 391. flow.container gates its country-cookie
    // redirect on login_mode=true, so Create Account always stays on /sleepio/nhs.
    if (!UserSession.getUserData()) {
      FlowService.setLocalProgress(NHS_FLOW_ID, 1, 0);
    }
    window.location.replace(`/sleepio/nhs${qs}`);
  }, [search]);

  return null;
};

export default CreateAccountPreFlow;
